import { BasketballEventStatusId } from '@collector/sportsapi-client-legacy'

import type { EventStatusAcronymConfig } from '../../configuration/eventStatusAcronymConfig'

export const eventStatusAcronymConfig: EventStatusAcronymConfig<BasketballEventStatusId> =
  {
    [BasketballEventStatusId.FirstQuarter]: 'Q1',
    [BasketballEventStatusId.SecondQuarter]: 'Q2',
    [BasketballEventStatusId.ThirdQuarter]: 'Q3',
    [BasketballEventStatusId.FourthQuarter]: 'Q4',
  }
